import { fetchConToken } from "../helpers/fetch";

const TipoDocumentacionesEfectorService = {
    traerPorSubtipoEfector:(idSubTipoEfector) => {
        return fetchConToken(`TipoDocumentacionesPorSubTipoEfector/${idSubTipoEfector}`)
    },
    crearRelacionDocumentacionSubtipoEfector: (data) => {
        return fetchConToken(`TipoDocumentacionesPorSubTipoEfector`, data, "POST")
    },
    actualizarRelacionDocumentacionSubtipoEfector: (id, data) => {
        return fetchConToken(`TipoDocumentacionesPorSubTipoEfector/${id}`, data, "PUT")
    },
    eliminarRelacionDocumentacionSubtipoEfector: (id) => {
        return fetchConToken(`TipoDocumentacionesPorSubTipoEfector/${id}`, {}, "DELETE")
    },
}

export { TipoDocumentacionesEfectorService as default }